import type { MaybeRefOrGetter } from 'vue';
import { queryOptions } from '@tanstack/vue-query';
import { PriorityQueryKey, TypeQueryKey } from '@/modules/common/enums/query-key.enum.ts';
import { CounterpartyApi } from '@/modules/counterparty/api/counterparty.api.ts';

export class CounterpartyQueryOptions {
  static BASE_KEY = 'counterparty';

  static getCount(enabled?: MaybeRefOrGetter<boolean>) {
    return queryOptions({
      queryKey: [PriorityQueryKey.Primary, CounterpartyQueryOptions.BASE_KEY, TypeQueryKey.Count],
      queryFn: (meta) => CounterpartyApi.getCount(meta.signal),
      enabled,
    });
  }

  static getTypes(signal?: AbortSignal) {
    return queryOptions({
      queryKey: [PriorityQueryKey.Secondary, CounterpartyQueryOptions.BASE_KEY, 'type'],
      queryFn: (meta) => CounterpartyApi.getTypes(signal ?? meta.signal),
    });
  }

  static getDistinct(signal?: AbortSignal) {
    return queryOptions({
      queryKey: [PriorityQueryKey.Secondary, CounterpartyQueryOptions.BASE_KEY, 'distinct'],
      queryFn: (meta) => CounterpartyApi.getDistinct(signal ?? meta.signal),
    });
  }
}
